<template>
  <div class="jobs-create" v-loading="loading">
    <el-form>
      <div v-if="$route.params.type !== 'line' && !lineId">
        <el-form-item
          :label="$route.params.type && $route.params.type !== 'job' ? tr[$route.params.type] : `Название вида работ`"
        >
          <el-input v-model="form.name"/>
        </el-form-item>
      </div>
      <el-form-item :label="`Чел./часы на единицу объема`" v-if="$route.params.type === 'job'">
        <el-input type="number" v-model="form.unit_for_value"/>
      </el-form-item>
      <el-form-item
        v-if="$route.params.type === 'welder' || $route.params.type === 'line' || lineId"
        :label="$route.params.type === 'welder' ? `Номер удостоверения` : `Номер линии`"
      >
        <el-input v-model="form.id"/>
      </el-form-item>
      <el-form-item :label="`Марка стали по умолчанию`" v-if="$route.params.type === 'line'">
        <el-input v-model="form.steel_grade_default" @input="setDefaultMark"/>
      </el-form-item>
      <div
        v-else-if="$route.params.type !== 'team' && $route.params.type !== 'executor' && $route.params.type !== 'welder_cons' && $route.params.type !== 'welder' ">
        <unit-select v-model="form.unit"/>
        <el-checkbox v-model="form.analytics">Показывать в аналитике</el-checkbox>
      </div>

      <el-form-item :label="`Клеймо`" v-if="$route.params.type === 'welder'">
        <el-input v-model="form.stamp"/>
      </el-form-item>
      <div class="joint" v-if="$route.params.type === 'line' || lineId">
        <div>
          <h3>{{ createJoinInternal ? 'Доп. стык' : 'Стыки' }}</h3>
          <div class="s-p">
            <div class="link-block">
              <el-checkbox v-model="createJoinInternal">Доп. стык</el-checkbox>
            </div>
            <el-form-item :label="`Номер стыка`" v-if="createJoinInternal || lineId">
              <el-input placeholder="Задайте номер стыка" v-model="joints.start"/>
            </el-form-item>
            <el-form-item :label="`Номер стыка`" v-else>
              <el-input placeholder="C" v-model="joints.start"/>
              <el-input placeholder="По" v-model="joints.end"/>
            </el-form-item>
          </div>
        </div>
        <div class="in-line">
          <el-form-item :label="`Диаметр`">
            <el-input v-model="joints.dia" @input="onJoinInput(joints)"/>
          </el-form-item>
          <el-form-item :label="`Толщина`">
            <el-input v-model="joints.thi" @input="onJoinInput(joints)"/>
          </el-form-item>
          <el-form-item :label="`Дюймы`">
            <el-input v-model="joints.inc"/>
          </el-form-item>
        </div>
        <el-form-item :label="`Марка стали`">
          <el-input v-model="joints.steel_grade"/>
        </el-form-item>

        <el-button style="width: 100%" type="primary" plain @click="addJoints">
          {{ createJoinInternal ? 'Добавить стык' : 'Добавить стыки' }}
        </el-button>
      </div>
      <div class="joints-list">
        <div class="joint-li" v-for="(join, index) in form.joints_labels" :key="index">
          <div class="li-header">
            <span>{{ join.id }} </span>
            <el-checkbox v-model="join.additional">Доп. стык</el-checkbox>
            <el-button type="danger" plain size="mini" @click="deleteJoint(index)">Удалить</el-button>
          </div>
          <div class="in-line">
            <el-form-item :label="`Диаметр`">
              <el-input v-model="join.dia" @input="onJoinInput(join)"/>
            </el-form-item>
            <el-form-item :label="`Толщина`">
              <el-input v-model="join.thi" @input="onJoinInput(join)"/>
            </el-form-item>
            <el-form-item :label="`Дюймы`">
              <el-input v-model="join.inc"/>
            </el-form-item>
          </div>
          <el-form-item :label="`Марка стали`">
            <el-input v-model="join.steel_grade"/>
          </el-form-item>
        </div>
      </div>
      <div class="jobs-create__buttons">
        <el-button @click="close" v-if="!$route.params.id">Отмена</el-button>
        <el-button v-else type="danger" @click="deleteObject">Удалить</el-button>

        <el-button v-if="!$route.params.id" type="primary" @click="save">Сохранить</el-button>
        <el-button v-else type="primary" @click="edit">Сохранить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {v4 as uuidv4} from 'uuid';
import {toFloat} from '../../../utils/numberUtils';
import FilterSelect from '../../../components/FilterSelect';
import work_units from '../../../data/work_units';
import {getUnits} from '../../../firestore/units';
import UnitSelect from '../components/unitSelect';
import {getInches} from "../../../firestore/inch";


export default {
  name: 'Create',
  props: ['lineId'],
  components: {UnitSelect, FilterSelect},
  data() {
    return {
      loading: false,
      checked: true,
      createJoinInternal: false,
      joints_table: {},
      options: {
        units: {
          main: [],
          tech: work_units.tech
        },
      },
      joints: {
        start: null,
        end: null,
        dia: '',
        thi: '',
        inc: '',
      },
      form: {
        steel_grade_default: '',
        analytics: true,
        unit: {
          label: 'ед.',
          value: 'ед.',
        },
        unit_for_value: null,
        name: '',
        id: null,
        stamp: '',
        joints_labels: [],
        joints: [],
      },
      tr: {
        line: 'Название линии',
        welder: 'ФИО сварщика',
        welder_cons: 'Сварочные материалы',
        team: 'ФИО',
        executor: 'ФИО',
      },
    };
  },

  async mounted() {
    this.joints_table = await getInches(this.$store.state.project.id);
    this.options.units.main = await getUnits(this.$store.state.project.id);

    if (this.$route.params.id) {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .doc(this.$route.params.id).get().then((response) => {
        const data = response.data();

        this.form = {
          ...data,
          unit: this.options.units.main.find((f) => f.label === (data.unit && data.unit.label) || f.value === (data.unit && data.unit.value)),
          joints_labels: _.orderBy(data.joints_labels, 'id', 'asc'),
        };
      });
    }
  },

  methods: {
    setDefaultMark(mark) {
      this.joints.steel_grade = mark;
    },
    onJoinInput(joint) {
      const value = this.joints_table.find((d) => d.dia == joint.dia && d.width == joint.thi);

      if (value && value.inch && String(value.inch).length) {
        joint.inc = toFloat(value.inch);
      } else {
        joint.inc = '';
      }
    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$emit('update');
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
    close() {
      this.$router.go(-1);
    },
    async deleteJoint(index) {
      const joints_labels = [...this.form.joints_labels];
      const joints = [...this.form.joints];
      _.remove(joints, {
        label: joints_labels[index].id,
      });
      joints_labels.splice(index, 1);
      this.form.joints_labels = joints_labels;
      this.form.joints = this.prepareData();
    },
    addJoints() {
      const joints_labels = this.form.joints_labels || [];
      const joints = this.form.joints || [];

      if (this.joints.end && !this.createJoinInternal) {
        for (let i = Number(this.joints.start); i < Number(this.joints.end) + 1; i++) {
          if (joints.find((j) => String(j.id).toUpperCase() === String(i).toUpperCase())) {
            this.$notify({
              offset: 60,

              title: 'Упс... ',
              message: `Стык с номером ${i} уже существует`,
              type: 'error',
            });
            return;
          }
        }
        joints_labels.push(
          {
            id: `C ${this.joints.start} - по ${this.joints.end}`.toUpperCase(),
            dia: toFloat(this.joints.dia),
            thi: toFloat(this.joints.thi),
            uid: uuidv4(),
            start: this.joints.start,
            end: this.joints.end,
            additional: this.createJoinInternal,
            inc: toFloat(this.joints.inc),
            steel_grade: this.joints.steel_grade || '',
          },
        );
      } else {
        if (joints.find((j) => String(j.id).toUpperCase() === String(this.joints.start).toUpperCase())) {
          this.$notify({
            offset: 60,

            title: 'Упс... ',
            message: `Стык с номером ${this.joints.start} уже существует`,
            type: 'error',
          });
          return;
        }
        joints_labels.push(
          {
            id: String(this.joints.start).toUpperCase(),
            dia: toFloat(this.joints.dia),
            thi: toFloat(this.joints.thi),
            uid: uuidv4(),
            inc: toFloat(this.joints.inc),
            additional: this.createJoinInternal,
            steel_grade: this.joints.steel_grade || '',
          },
        );
      }

      this.joints = {
        start: null,
        end: null,
        dia: '',
        thi: '',
        inc: '',
        steel_grade: this.form.steel_grade_default,
      };

      this.form.joints_labels = _.orderBy(joints_labels, 'id', 'asc');
      this.form.joints = this.prepareData();
    },
    prepareData() {
      const result = [];
      this.form.joints_labels.forEach((joints) => {
        const isRange = joints.id.includes('- по');

        if (joints.start && joints.end) {
          for (let i = Number(joints.start); i < Number(joints.end) + 1; i++) {
            result.push(
              {
                id: String(i).toUpperCase(),
                dia: toFloat(joints.dia),
                thi: toFloat(joints.thi),
                uid: joints.uid || uuidv4(),
                additional: joints.additional,
                inc: toFloat(joints.inc),
                steel_grade: joints.steel_grade || '',
              },
            );
          }
        } else if (isRange) {
          const range = joints.id.split(' ').map(Number);
          const range_numbers = range.filter((r) => !isNaN(r));
          for (let i = Number(range_numbers[0]); i < Number(range_numbers[1]) + 1; i++) {
            result.push(
              {
                id: String(i).toUpperCase(),
                dia: toFloat(joints.dia),
                thi: toFloat(joints.thi),
                uid: joints.uid || uuidv4(),
                additional: joints.additional,
                inc: toFloat(joints.inc),
                steel_grade: joints.steel_grade || '',
              },
            );
          }
        } else {
          result.push(
            {
              id: joints.id,
              dia: toFloat(joints.dia),
              thi: toFloat(joints.thi),
              uid: joints.uid || uuidv4(),
              additional: joints.additional,
              inc: toFloat(joints.inc),
              steel_grade: joints.steel_grade || '',
            },
          );
        }
      });
      return result;
    },
    edit() {
      this.form.joints = this.prepareData();
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type').doc(this.$route.params.id)
        .update({
          ...this.form,
        }).then((add) => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отредактировано',
          type: 'success',
        });
        setTimeout(() => this.$router.go(-1), 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    async save() {
      this.form.joints = this.prepareData();

      if (this.$route.params.type === 'line' && !this.form.joints.length) {
        this.addJoints();
      }

      const work_type_s = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .orderBy("index", 'desc').limit(1)
        .get();

      let work_s = {
        index: 0
      };

      work_type_s.forEach((subDoc) => {
        work_s = subDoc.data();
      });

      this.loading = true;

      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .add({
          ...this.form,
          index: (work_s.index || 0) + 1,
          type: (this.$route.params.type && this.$route.params.type.toLowerCase()) || 'JOB',
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Добавлено',
          type: 'success',
        });
        this.form = {
          name: '',
        };
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  }
  ,
}
;
</script>

<style scoped lang="scss">
.jobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 128px;

  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.joint {
  box-shadow: 0px 0px 8px 0px #ccc;
  background: #f7f7f7;
  padding: 10px 20px;
  border-radius: 5px;
}

.in-line {
  display: flex;
}

.jobs-create__buttons {
  position: fixed;
  bottom: 0;
  max-width: 382px;
  width: calc(100% - 40px);
  background: #fff;
  border-top: 1px solid #ccc;
  padding: 10px;
}

.joint-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
}

.li-header {
  display: flex;
  justify-content: space-between;
  flex: 1;
  width: 100%;
}

.link-block {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;
  margin-bottom: -26px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/WorkType/Create.vue